import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext.js';

function Navbar() {
  const { language, translations, toggleLanguage } = useContext(LanguageContext);

  return (
    <nav className="navbar">
      {/* Основные ссылки */}
      <ul>
        <li>
          <Link to="/">{translations[language].navbar.home}</Link>
        </li>
        <li>
          <Link to="/about">{translations[language].navbar.about}</Link>
        </li>
        <li>
          <Link to="/projects">{translations[language].navbar.projects}</Link>
        </li>
        <li>
          <Link to="/contact">{translations[language].navbar.contact}</Link>
        </li>
      </ul>

      {/* Языковой переключатель */}
      <div className="language-container">
        <div className="language" onClick={toggleLanguage}>
          {translations[language].navbar.switchLanguage}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;